import { IConversation } from '@vc/models/proto/base/conversations'
import { ConversationsIndexRO } from '@vc/models/proto/ro/conversations'

export const setNewConversations = (
  page: number,
  oldConversations: IConversation[],
  response: ConversationsIndexRO
) => {
  const { data, meta } = response ?? { data: [], meta: {} }
  return page === 1
    ? { data, meta }
    : {
        data: [...(oldConversations ?? []), ...response.data],
        meta,
      }
}
